import { __assign, __extends } from "tslib";
// DS: I16
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var ColorDrop = /** @class */ (function (_super) {
    __extends(ColorDrop, _super);
    function ColorDrop() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColorDrop.prototype.render = function () {
        return (React.createElement(IconWrap, __assign({}, this.props),
            React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                React.createElement("defs", null,
                    React.createElement("path", { d: "M5.33333333,0 C3.778,5.972 0,6.792 0,10.7166667 C0,13.6353333 2.386,16 5.33333333,16 C8.28066667,16 10.6666667,13.6353333 10.6666667,10.7166667 C10.6666667,6.792 6.88866667,5.972 5.33333333,0 Z M5.72933333,13.718 C7.56,12.7793333 8.17,10.4793333 7.23133333,7.79133333 C10.0833333,10.8313333 8.40466667,13.8593333 5.72933333,13.718 Z", id: "color-drop-path-1" })),
                React.createElement("g", { fill: "none", fillRule: "evenodd" },
                    React.createElement("g", { transform: "translate(7 4)" },
                        React.createElement("mask", { id: "color-drop-mask", fill: "currentColor" },
                            React.createElement("use", { xlinkHref: "#color-drop-path-1" })),
                        React.createElement("use", { fill: "currentColor", fillRule: "nonzero", xlinkHref: "#color-drop-path-1" }),
                        React.createElement("g", { mask: "url(#color-drop-mask)", fill: "currentColor" },
                            React.createElement("rect", { width: "24", height: "24", transform: "translate(-7 -4)" })))))));
    };
    return ColorDrop;
}(React.Component));
export { ColorDrop };
export default ColorDrop;
//# sourceMappingURL=ColorDrop.js.map